import Navbar from "../Component/LandingV2/Navbar";
import "./ContactPage.scss";

const ContactPage = () => {
  return (
    <>
      <Navbar />
      <div className="contact-page">
        {/* ── Left Panel ───────────────────────────── */}
        <div className="cp-left">
          <div className="cp-left-inner">
            <div className="cp-mail-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <h1 className="cp-heading">Contact us</h1>
            <p className="cp-desc">
              We are always looking for ways to improve our products and
              services. Reach out and let us know how we can help you.
            </p>

            {/* <div className="cp-contact-row">
              <span>contact@algofabric.ai</span>
              <span className="cp-dot">•</span>
              <span>+91 20 4880 7000</span>
              <span className="cp-dot">•</span>
              <span>support@algofabric.ai</span>
            </div> */}

            <blockquote className="cp-quote">
              "Empowering every investor with the intelligence to act with clarity."
            </blockquote>

          </div>
        </div>

        {/* ── Right Panel ──────────────────────────── */}
        <div className="cp-right">
          <div className="cp-right-inner">

            {/* Header */}
            <div className="cp-right-header">
              <span className="cp-right-badge">Our Office</span>
              <h2 className="cp-right-title">We'd love to hear from you</h2>
              <p className="cp-right-sub">
                Drop by, call, or send us a note — we're always happy to connect.
              </p>
            </div>

            {/* Featured address card */}
            <div className="cp-address-card">
              <div className="cp-cg-icon cp-cg-icon--lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="cp-cg-body">
                <div className="cp-ci-label">Registered Office</div>
                <div className="cp-ci-value cp-ci-value--wrap">
                  3, VIJAY SALES - BANER, Ideas to Impacts Building, Pallod Farm Lane,
                  Near Baner Rd, Pune, Maharashtra 411069
                </div>
              </div>
            </div>

            {/* Contact grid */}
            <div className="cp-contact-grid">
              {[
                {
                  icon: <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>,
                  label: "Company", value: "AlgoAnalytics Private Limited", href: undefined as string | undefined, fullWidth: false
                },
                {
                  icon: <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>,
                  label: "Website", value: "www.algoanalytics.com", href: "https://www.algoanalytics.com", fullWidth: false
                },
                {
                  icon: <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>,
                  label: "Email", value: "algofabric@algoanalytics.com", href: "mailto:algofabric@algoanalytics.com", fullWidth: true
                },
              ].map(({ icon, label, value, href, fullWidth }) => {
                const inner = (
                  <>
                    <div className="cp-cg-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">{icon}</svg>
                    </div>
                    <div className="cp-cg-body">
                      <div className="cp-ci-label">{label}</div>
                      <div className="cp-ci-value">{value}</div>
                    </div>
                  </>
                );
                const cls = `cp-cg-item${fullWidth ? " cp-cg-item--full" : ""}${href ? " cp-cg-item--link" : ""}`;
                return href ? (
                  <a
                    className={cls}
                    key={label}
                    href={href}
                    target={href.startsWith("http") ? "_blank" : undefined}
                    rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  >
                    {inner}
                  </a>
                ) : (
                  <div className={cls} key={label}>{inner}</div>
                );
              })}
            </div>

            {/* CTA */}
            <a className="cp-cta-btn" href="mailto:algofabric@algoanalytics.com">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Write to us
            </a>

          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
